// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";

const firebaseConfig = {
  apiKey: "AIzaSyCdk89RXbqdpAqBQb3w-zANbGSSitYkQ1k",
  authDomain: "mehak-chatapp-3ae93.firebaseapp.com",
  projectId: "mehak-chatapp-3ae93",
  storageBucket: "mehak-chatapp-3ae93.appspot.com",
  messagingSenderId: "108724771318",
  appId: "1:108724771318:web:b99909051b260787c44fd7",
  measurementId: "G-S9MNZ8T6MX"
};


export const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);